import React from 'react'

import styles from './SharedComponent.less'

export function Loader (props) {

  const classNames = [styles.absolutePosition, styles.dock, styles.dockFull, styles.zIndex10, 'grid-x align-center align-middle'];

  return <div className={classNames.join(' ')}>
    <div className={classNames.join(' ')}>
      <img className={'loading-animation-large'} src="/content/images/LogoSymbol.png" />
    </div>
  </div>
}
